// extracted by mini-css-extract-plugin
export default {"button":"Qo-z","reviewSort":"Ro-z"};